import { Map } from "immutable";

import { ASSET_URL } from "../constants/DesignContextConstants";
import config from "../config/app";
import { ensureHTTPS } from "./DomainUtils";
import AssetManager from "../managers/AssetManager";

const generateDesignAssetUrl =
  (context) =>
  ({ op, key, provider, elemProps, content }) => {
    const assetUrl = context.get(ASSET_URL);

    return elemProps && content
      ? AssetManager.getAssetURL({ content, elemProps, assetUrl })
      : AssetManager.getURL({ key, op, assetUrl, provider });
  };

const DesignContextUtils = {
  createContext: (props = {}) =>
    Map({
      [ASSET_URL]: ensureHTTPS(props[ASSET_URL] ?? config.assetURL),
    }),
  fromContext: (context) => {
    if (!context) {
      throw new Error("Context is required");
    }

    return {
      generateDesignAssetUrl: generateDesignAssetUrl(context),
    };
  },
};

export default Object.freeze(DesignContextUtils);
